import {createAction, createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';
import {createPayloadForSavePayment} from 'desktop/pages/checkout/utils/createPayloadForPayments/createPayloadForPayments';
import {PaymentInfoType} from 'desktop/types/PaymentInfoType';
import {SavePaymentDataType} from 'desktop/types/savePaymentDataType';
import {apiConfig, HTTP_REQUEST_HEADER, HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE} from 'libs/api/api';

import {
    completeOrderReview,
    completeOrderReviewPaypal,
} from '../../../actions/completeOrder/completeOrder';

export const initialState: SavePaymentDataType = {
    isLoading: false,
    message: '',
    status: '',
};

export const setLoadingSavePayment = createAction<boolean>('CHECKOUT@SET_LOADING_SAVE_PAYMENT');

export const savePayment = createAsyncThunk<
    {data: {message: string}},
    {paymentInfo: PaymentInfoType; formKey?: string},
    {rejectValue: {response: {data: SavePaymentDataType}}}
>('CHECKOUT@SAVE_PAYMENT', async ({formKey, paymentInfo}, {rejectWithValue}) => {
    try {
        const data = createPayloadForSavePayment(paymentInfo.method.toString(), {
            formKey,
            paymentInfo,
        });

        return await apiConfig.instanceGusaBackend.request({
            data,
            headers: {
                [HTTP_REQUEST_HEADER.CONTENT_TYPE]:
                    HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.MULTIPART_FORM_DATA,
            },
            method: 'post',
            url: `${ENDPOINTS.CHECKOUT_SET_PAYMENT}`,
        });
    } catch (e) {
        return rejectWithValue(e);
    }
});

export const cleanError = createAction('CHECKOUT@CLEAN_ERROR');

/**
 * savePaymentData reducer
 *
 * @return {SavePaymentDataType} - save Payment Data state
 */
export const savePaymentData = createReducer(initialState, builder =>
    builder
        .addCase(cleanError, state => ({
            ...state,
            message: '',
        }))
        .addCase(completeOrderReview.rejected, state => ({
            ...state,
            isLoading: false,
        }))
        .addCase(completeOrderReviewPaypal.rejected, state => ({
            ...state,
            isLoading: false,
        }))
        .addCase(savePayment.fulfilled, (state, action) => ({
            ...state,
            ...action.payload.data,
            status: 'FULFILLED',
        }))
        .addCase(savePayment.pending, state => ({
            ...state,
            status: 'PENDING',
        }))
        .addCase(savePayment.rejected, (state, action) => ({
            ...state,
            ...action.payload?.response?.data,
            isLoading: false,
            status: 'REJECTED',
        }))
        .addCase(setLoadingSavePayment, (state, action) => ({...state, isLoading: action.payload})),
);
